import { RootState } from "../../../core/store";
import { VOYAGES_REPORT, TVoyagesReportSliceState, TReportRequestParams } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: TVoyagesReportSliceState = {
    voyagesReportData: null,
    voyagesReportLoading: false,
    voyagesReportError: null,
};

const voyagesReportSlice = createSlice({
    name: VOYAGES_REPORT,
    initialState,
    reducers: {
        submitVoyagesReportRequestAction: (state: TVoyagesReportSliceState, _: PayloadAction<TReportRequestParams>) => {
            state.voyagesReportLoading = true;
            state.voyagesReportError = null;
            state.voyagesReportData = null;
        },
        submitVoyagesReportSuccessAction: (state: TVoyagesReportSliceState, { payload: data }: PayloadAction<any>) => {
            state.voyagesReportLoading = false;
            state.voyagesReportData = data;
            state.voyagesReportError = null;
        },
        submitVoyagesReportErrorAction: (state: TVoyagesReportSliceState, { payload: error }: PayloadAction<any>) => {
            state.voyagesReportLoading = false;
            state.voyagesReportData = null;
            state.voyagesReportError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
        clearVoyagesReportStateAction: (state: TVoyagesReportSliceState) => {
            state.voyagesReportLoading = false;
            state.voyagesReportData = null;
            state.voyagesReportError = null;
        },
    },
});

export const voyagesReportActions = {
    ...voyagesReportSlice.actions
};

export default voyagesReportSlice.reducer;

export const selectVoyagesReportData = (state: RootState) =>
    state.voyagesReportSlice.voyagesReportData;
export const selectVoyagesReportLoading = (state: RootState) =>
    state.voyagesReportSlice.voyagesReportLoading;
export const selectVoyagesReportError = (state: RootState) =>
    state.voyagesReportSlice.voyagesReportError;
